import React, { useRef, useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Navbar from "react-bootstrap/Navbar";
import axios from "../../../Hook/utils/constants/server";
import { Col, Dropdown } from "react-bootstrap";
import {
  List,
  ThreeDotsVertical,
  Box,
  HeartFill,
  ChatLeftQuoteFill,
  GiftFill,
  Shop,
  Lock
} from "react-bootstrap-icons";

import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useSidebarCollapse } from "../Sidebar/SidebarCollapseContext";
import "./Header.css";
import LogoImg from "../../Image/logo.png";
import { useNavigate } from "react-router-dom";
import whiteLogo from "../../Image/login-logo.png";
import { enqueueSnackbar } from "notistack";

const Header = () => {
  const { toggleCollapsed } = useSidebarCollapse();
  const [profile, setProfile] = useState(false);
  const [setting, setSetting] = useState(false);
  const [mail, setMail] = useState(false);
  const babaji = useNavigate();
  const [notification, setNotification] = useState(false);
  const [clickSearch, setClickSearch] = useState(false);
  const [clickSearchInput, setClickSearchInput] = useState("");
  const clickOutside = useRef();

  //  Load active app from localStorage or default to Wishlist Guru
  const [activeApp, setActiveApp] = useState(
    localStorage.getItem("activeApp") || "Wishlist Guru"
  );

  const selectedLayoutTheme = useSelector(
    (state) => state.colorTheme.layoutTheme
  );

  const selectedColorTheme = useSelector(
    (state) => state.colorTheme.colorTheme
  );

  const handleLog = () => {
    axios
      .get("/user/logout")
      .then((response) => {
        if (response.data === "Logged out successfully") {
          localStorage.clear();
          babaji("/");
          enqueueSnackbar("Logged out successfully", {
            variant: "success",
            autoHideDuration: 2000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        } else {
          enqueueSnackbar("Oops unable to logout , please try again later", {
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            autoHideDuration: 2000,
          });
        }
      })
      .catch((er) => {});
  };

  //  Handle switching between apps
  const handleSwitchApp = (appName) => {
    setActiveApp(appName);
    localStorage.setItem("activeApp", appName);
    enqueueSnackbar(`${appName} Activated`, {
      variant: "info",
      autoHideDuration: 1500,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });

    // navigate to the correct route (you can adjust routes)
    if (appName === "Wishlist Guru") {
      babaji("/");
    } else if (appName === "Quotes Guru") {
      babaji("/");
    } else if (appName === "Pre-order Guru") {
      babaji("/");
    } else if (appName === "Gift-registry Guru") {
      babaji("/");
    }else if (appName === "B2B Guru") {
      babaji("/"); 
    }else if (appName === "Lock Guru") {
      babaji("/"); 
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        clickOutside &&
        clickOutside.current &&
        !clickOutside.current.contains(event.target)
      ) {
        setMail(false);
        setNotification(false);
        setSetting(false);
        setProfile(false);
        setClickSearch(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [clickOutside]);

  return (
    <Navbar
      expand="lg"
      className={
        selectedLayoutTheme === "right-align-layout"
          ? "main-header reverse-header"
          : "main-header "
      }
      fixed="top"
    >
      <Col md={2}>
        <button onClick={toggleCollapsed}>
          <List />
        </button>
        <Navbar.Brand href="#" className="brand-name">
          {selectedColorTheme === "dark-theme" ? (
            <img alt="Site Logo" src={whiteLogo} />
          ) : (
            <img alt="Site Logo" src={LogoImg} />
          )}
        </Navbar.Brand>
      </Col>

      <Navbar.Toggle aria-controls="basic-nav-navbar">
        <ThreeDotsVertical />
      </Navbar.Toggle>
      <Navbar.Collapse id="basic-nav-navbar">
        <div className="d-flex ms-auto">
          <div
            className="headerProfile d-flex align-items-center gap-2"
            style={{ marginRight: "5px" }} //  pushes it extreme right with 5px padding
          >
            {/* App Switcher */}
            <Dropdown className="app-switcher">
              <Dropdown.Toggle id="dropdown-apps">{activeApp}</Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  active={activeApp === "Wishlist Guru"}
                  onClick={() => handleSwitchApp("Wishlist Guru")}
                >
                  <HeartFill size={16} /> Wishlist Guru
                </Dropdown.Item>
                <Dropdown.Item
                  active={activeApp === "Quotes Guru"}
                  onClick={() => handleSwitchApp("Quotes Guru")}
                >
                  <ChatLeftQuoteFill size={16} /> Quotes Guru
                </Dropdown.Item>
                <Dropdown.Item
                  active={activeApp === "Pre-order Guru"}
                  onClick={() => handleSwitchApp("Pre-order Guru")}
                >
                  <Box size={16} /> Pre-order Guru
                </Dropdown.Item>
                <Dropdown.Item
                  active={activeApp === "Gift-registry Guru"}
                  onClick={() => handleSwitchApp("Gift-registry Guru")}
                >
                  <GiftFill size={16} /> Gift-registry Guru
                </Dropdown.Item>
                <Dropdown.Item
                  active={activeApp === "B2B Guru"}
                  onClick={() => handleSwitchApp("B2B Guru")}
                >
                  <Shop size={16} /> B2B Guru
                </Dropdown.Item>
                <Dropdown.Item
                  active={activeApp === "Lock Guru"}
                  onClick={() => handleSwitchApp("Lock Guru")}
                >
                  <Lock size={16} /> Lock Guru
                </Dropdown.Item>
                
              </Dropdown.Menu>
            </Dropdown>

            {/* Logout */}
            <Link
              onClick={handleLog}
              style={{
                color: "#df1a2dff",
              }}
            >
              Log out
            </Link>
          </div>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
